// extracted by mini-css-extract-plugin
export default {"actionCreateContainer":"styles-module__actionCreateContainer__src-labstep-web-components-Metadata-Manager-_VEkFb"};